import createAxe from '../../middlewares/Axe';
import * as types from './actionTypes';
import { expRetry } from '../../helpers/timeouts';
import { cancelOperation } from '../authActions';

export function setStateWarnings(items) {
  return {
    type: types.SET_STATE_WARNINGS,
    items
  };
}

// Fetch state warnings for the current customer + machine.
export function fetchStateWarnings(retry = 0) {
  return async function(dispatch, getState) {
    try {
      const axe = createAxe(getState());
      const res = await axe('/3971cc86b21c6924/v2/state-warnings/machine', {
        method: 'GET',
        headers: {
          'Customer-Token': `Bearer ${getState().client.client_id}`,
          'Atm-Token': `Bearer ${getState().machine.atm_id}`,
          'Session-Id': getState().purchase.idtx
        }
      });
      const items = (res.data && res.data.data) || [];
      dispatch(setStateWarnings(items));
      return items;
    } catch (error) {
      return expRetry(
        (_retry) => dispatch(fetchStateWarnings(_retry)),
        () => dispatch(cancelOperation()),
        retry
      );
    }
  };
}

// Acknowledge the displayed warnings. Fire-and-forget: failures are logged
// but never block the user (the kiosk has already navigated on).
export function acknowledgeStateWarnings(warningIds) {
  return async function(dispatch, getState) {
    if (!warningIds || warningIds.length === 0) return;
    try {
      const axe = createAxe(getState());
      await axe('/3971cc86b21c6924/v2/state-warnings/machine/acknowledge', {
        method: 'POST',
        headers: {
          'Customer-Token': `Bearer ${getState().client.client_id}`,
          'Atm-Token': `Bearer ${getState().machine.atm_id}`,
          'Session-Id': getState().purchase.idtx
        },
        data: { warning_ids: warningIds }
      });
    } catch (error) {
      console.error('acknowledgeStateWarnings failed (fire-and-forget):', error);
    }
  };
}